import React from 'react'
import Svg, { G, Path, SvgProps } from 'react-native-svg'

import { Color } from '../../style'

export interface Props extends SvgProps {}
const IconMenu = (props: Props) => {
  const { width, height, color, ...otherProps } = props
  return (
    <Svg
      width={width}
      height={height}
      viewBox={`0 0 ${IconMenu.dimensions.width} ${IconMenu.dimensions.height}`}
      {...otherProps}
    >
      <G fill={color || Color.premiumBlack} fillRule="nonzero">
        <Path d="M35.805 0H1a1 1 0 100 2h34.805a1 1 0 000-2zM35.805 11.43H1a1 1 0 100 2h34.805a1 1 0 000-2zM35.805 22.86H1a1 1 0 100 2h34.805a1 1 0 000-2z" />
      </G>
    </Svg>
  )
}

IconMenu.dimensions = {
  width: 37,
  height: 25,
}

export default IconMenu
